import React from 'react';
import PropTypes from 'prop-types';
import './ListItem.scss';

const item = (props) => {
  const { title, description, callback } = props;

  return (
    <div className="Placeholders-List-Item" onClick={() => callback()}>
      {title}
      <span>{description}</span>
    </div>
  );
};


item.defaultProps = {
  description: '',
  callback: () => {
  },
};

item.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  callback: PropTypes.func,
};

export default item;
